function getAncestorWhere(element, condition) {
  if (!element) {
    return null;
  }
  const ancestor = element.parentElement;
  return condition(ancestor) ? ancestor : getAncestorWhere(ancestor, condition);
}
function getAncestorWhereUntil(element, condition, until) {
  return getAncestorWhere(element, (el) => condition(el) || until(el));
}
export {
  getAncestorWhere,
  getAncestorWhereUntil
};
//# sourceMappingURL=ancestors.js.map
